<template>
  <div>
    <div v-for="(page, index) in pageGroupedElements" :key="'page-' + index" class="position-relative dinA4">
      <img :src="require('@/assets/international-header.png')" class="mb-0 page__header" />
      <div v-if="pageGroupedElements[index][0].type !== 'huge'" class="page__container">
        <div v-for="(element, elementIndex) in page" :key="'element-' + elementIndex">
          <div v-if="element.type === 'table'">
            <div v-if="element.id === 'INTEXP'">
              <PdfProductTable :type="element.tableType" :tableData="expressTables[0]" :tableId="'EUROPE'"
                :image="element.imageUrl" :subTableId="element.id" />
              <PdfProductTable :type="element.tableType" :tableData="expressTables[1]" :tableId="'WORLD'"
                :image="element.imageUrl" />
            </div>
            <div v-else-if="element.id === 'INTSTD'">
              <PdfProductTable :type="element.tableType" :tableData="productTableList[element.id]" :tableId="'EUROPE'"
                :image="element.imageUrl" :subTableId="element.id" />
            </div>
            <div v-else class="d-flex justify-center">
              <PdfProductTable :type="element.tableType" :tableData="productTableList[element.id]" :tableId="element.id"
                :image="element.imageUrl" />
            </div>
          </div>

          <div v-else class="d-flex">
            <div>
              <p class="body-2 body-2--bold mb-0 mt-4 ml-0 pl-0">
                {{ element.intro }}
              </p>
              <p v-if="element.intro2" class="body-2 body-2--bold mb-0 mt-0 ml-0 pl-0">
                {{ element.intro2 }}
              </p>
              <ul v-if="element.list" class="list-style-none body-2 justify-text">
                <li v-for="(listElement, indexList) in element.list" :key="'elementList' + indexList" class="pl-4"
                  v-html="listElement" />
              </ul>
              <p v-if="element.next" class="body-2 body-2--bold mb-0 mt-4">
                {{ element.title ? element.title : 'Otras consideraciones:' }}
              </p>
              <ul v-if="element.next" class="list-style-none body-2 justify-text">
                <li class="pl-4">
                  - Envíos que superen las dimensiones (SPECIAL HANDLING Exceed Dimensions): Se aplicará un
                  suplemento de {{ getAdditionalServiceById('SPC_HAND_EXC_DIM').value}} € en los envíos en los que uno o más bultos pese 30 kg o más y/o la suma del alto,
                  ancho y largo supere los 240 cm con ninguna de las medidas superior a 150 cm.
                </li>
                <li class="pl-4 pt-4">
                  <b>Nota Importante:</b> Los envíos con valor comercial a Países fuera de la Unión
                  Europea deben ir acompañados factura comercial original y 4 copias firmadas y
                  selladas por el exportador y redactadas en inglés o en el idioma oficial del País de
                  destino.
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div v-else>
        <img :src="require('@/assets/huge-table-2024.png')" class="pl-0 pr-0 page__header" />
        <div class="page__container text-center">
          <ul class="list-style-none body-2">
            <li>Consultar = Consultar estos destinos con el Consultor Comercial de su Zona.</li>
            <li>
              CTT Express se reserva el derecho de anular y/o modificar en cualquier momento las
              zonas de servicio ofertadas.
            </li>
            <li>
              Los tiempos de tránsito son orientativos y pueden variar en función de la ciudad u Origen y Destino de los mismos.
            </li>
          </ul>
        </div>
      </div>

      <Footer logo :page="previousPages + 1 + index" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { GET_PDF_PRODUCT_TABLE_LIST, GET_PRODUCT} from '@/store/modules/offer/getters'
import PdfProductTable from '@/containers/offer-form/sign-off/pdf-venta-directa-2026/PdfProductTable'
import Footer from '@/containers/offer-form/sign-off/pdf-venta-directa-2026/Footer'

export default {
  name: 'InternationalTables',
  components: {
    PdfProductTable,
    Footer,
  },
  data() {
    return {
      elements: [
        {
          type: 'table',
          subtype: 'double',
          imageUrl: require('@/assets/express-icon.png'),
          index: 13,
          id: 'INTEXP',
          tableType: 'international',
        },
        {
          type: 'table',
          imageUrl: require('@/assets/economy-icon.png'),
          index: 14,
          id: 'INTSTD',
          tableType: 'economy',
        },
        {
          type: 'text',
          relatedTable: 14,
          intro: 'Características principales del servicio CTT  Internacional Express / CTT Internacional Economy:',
          list: [
            '- Peso máximo por bulto: 30 kg',
            '- Medidas máximas por bulto: Suma de alto, ancho y largo no superior a 240 cm, con ninguna medida superior a 120 cm. Otros pesos y medidas consultar.',
            '- Cubicaje: <strong>Internacional Express:</strong> conversión volumétrica 200 kg/m3.',
            '- Cubicaje: <strong>Internacional Economy:</strong> conversión volumétrica 250 kg/m3.',
            '- Nº de bultos: Multibulto.',
          ],
          next: true,
        },
        { type: 'huge' },
        {
          type: 'table',
          imageUrl: require('@/assets/ecommerce-icon.png'),
          index: 15,
          id: 'ELIGHT',
          tableType: 'elight',
        },
        {
          type: 'text',
          relatedTable: 15,
          intro: 'Características del servicio CTT  Internacional Europa Light:',
          list: [
            '- Peso máximo por bulto: 10 Kg/bulto. A partir de 10 kg el envío será devuelto.',
            '- Dimesiones máximas: suma de alto, ancho y largo no superior a 150 com.',
            '- Medidas máximas: cualquiera de sus lados no superior a 50 cm.',
            '- Conversión volumétrica: 250 kg/m3',
            '- Nº de bultos: Monobulto.',
            '- Plazo de entrega: entre 3 a 6 días dependiendo del país.',
            '- Cobertura por siniestro (rotura o perdida): CMR (Indemnización máxima de 11,97€/kg)',
          ],
        },
      ],
      previousPages: 0,
    }
  },
  computed: {
    ...mapGetters('offer', [GET_PDF_PRODUCT_TABLE_LIST, GET_PRODUCT]),
    productTableList() {
      return this[GET_PDF_PRODUCT_TABLE_LIST]
    },
    isElightSelected() {
      const product = this[GET_PRODUCT]("ELIGHT")
      return product?.isPreSelected;
    },
    pageGroupedElements() {
      let pages = []
      let pageGroup = []
      let singleRow = false
      let rowElementCounter = 0

      const filteredElements = this.isElightSelected ?
        this.elements :
        this.elements.filter(element => (
          (element.type == "table" && element.index != 15) ||
          (element.type == "text" && element.relatedTable != 15) ||
          (element.type == "huge")
        ))

      for (let i = 0; i < filteredElements.length; i++) {
        let actualElement = filteredElements[i]
        if (actualElement.type === 'huge') {
          singleRow = true
        } else if (actualElement.type === 'table') {
          const numberOfRows = Object.keys(this.productTableList[actualElement.id].kgRows).length

          if (numberOfRows > 18 || actualElement.subtype === 'double') {
            singleRow = true
          }
        }
        if (singleRow) {
          if (rowElementCounter !== 0) {
            pages.push(pageGroup)
            pageGroup = []
            rowElementCounter = 0
          }
          pageGroup.push(actualElement)
          pages.push(pageGroup)
          pageGroup = []
          singleRow = false
        } else {
          pageGroup.push(actualElement)
          rowElementCounter++
          if (rowElementCounter === 2 || rowElementCounter === filteredElements.length) {
            pages.push(pageGroup)
            pageGroup = []
            rowElementCounter = 0
          }
        }
      }

      return pages
    },
    expressTables() {
      const fullTable = this.productTableList["INTEXP"]

      const firstTable = {
        headers: fullTable.headers.slice(-7),
        kgRows: {},
        addKilo: fullTable.addKilo.slice(-7),
      }
      Object.entries(fullTable.kgRows).forEach(([key, value]) => {
        firstTable.kgRows[key] = value.slice(-7);
      });

      const secondTable = {
        headers: fullTable.headers.slice(0, fullTable.headers.length - 7),
        kgRows: {},
        addKilo: fullTable.addKilo.slice(0, fullTable.headers.length - 7),
      }
      Object.entries(fullTable.kgRows).forEach(([key, value]) => {
        secondTable.kgRows[key] = value.slice(0, fullTable.headers.length - 7);
      });

      return [firstTable, secondTable]
    }
  },
  methods: {
    getAdditionalServiceById(id) {
      return this.$parent.getAdditionalServiceById(id)
    },
    getAdditionalServiceByDesc(desc) {
      return this.$parent.getAdditionalServiceByDesc(desc)
    },
  },
  created() {
    this.$emit('updateTotalPages', { InternationalTables: this.pageGroupedElements.length })
  },
  mounted() {
    this.previousPages = this.$parent.sectionPreviousPages('InternationalTables')
  },
}
</script>
